var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c(
        "el-col",
        [
          _c(
            "el-form",
            {
              ref: "labelForm",
              attrs: {
                model: _vm.labelForm,
                "label-width": "80px",
                size: "mini",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("show"),
                      expression: "showProperty('show')",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("chart.show") },
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      on: {
                        change: function ($event) {
                          return _vm.changeLabelAttr("show")
                        },
                      },
                      model: {
                        value: _vm.labelForm.show,
                        callback: function ($$v) {
                          _vm.$set(_vm.labelForm, "show", $$v)
                        },
                        expression: "labelForm.show",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.show")))]
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.labelForm.show,
                      expression: "labelForm.show",
                    },
                  ],
                },
                [
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("labelLine"),
                          expression: "showProperty('labelLine')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.pie_label_line_show") },
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          on: {
                            change: function ($event) {
                              return _vm.changeLabelAttr("labelLine")
                            },
                          },
                          model: {
                            value: _vm.labelForm.labelLine.show,
                            callback: function ($$v) {
                              _vm.$set(_vm.labelForm.labelLine, "show", $$v)
                            },
                            expression: "labelForm.labelLine.show",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("chart.pie_label_line_show")))]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("fontSize"),
                          expression: "showProperty('fontSize')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.text_fontsize") },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: _vm.$t("chart.text_fontsize"),
                            size: "mini",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.changeLabelAttr("fontSize")
                            },
                          },
                          model: {
                            value: _vm.labelForm.fontSize,
                            callback: function ($$v) {
                              _vm.$set(_vm.labelForm, "fontSize", $$v)
                            },
                            expression: "labelForm.fontSize",
                          },
                        },
                        _vm._l(_vm.fontSize, function (option) {
                          return _c("el-option", {
                            key: option.value,
                            attrs: { label: option.name, value: option.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("color"),
                          expression: "showProperty('color')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.text_color") },
                    },
                    [
                      _c("el-color-picker", {
                        staticClass: "color-picker-style",
                        attrs: { predefine: _vm.predefineColors },
                        on: {
                          change: function ($event) {
                            return _vm.changeLabelAttr("color")
                          },
                        },
                        model: {
                          value: _vm.labelForm.color,
                          callback: function ($$v) {
                            _vm.$set(_vm.labelForm, "color", $$v)
                          },
                          expression: "labelForm.color",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("position-pie"),
                          expression: "showProperty('position-pie') ",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.label_position") },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: _vm.$t("chart.label_position"),
                          },
                          on: {
                            change: function ($event) {
                              return _vm.changeLabelAttr("position")
                            },
                          },
                          model: {
                            value: _vm.labelForm.position,
                            callback: function ($$v) {
                              _vm.$set(_vm.labelForm, "position", $$v)
                            },
                            expression: "labelForm.position",
                          },
                        },
                        _vm._l(_vm.labelPositionPie, function (option) {
                          return _c("el-option", {
                            key: option.value,
                            attrs: { label: option.name, value: option.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("position-h"),
                          expression: "showProperty('position-h') ",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.label_position") },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: _vm.$t("chart.label_position"),
                          },
                          on: {
                            change: function ($event) {
                              return _vm.changeLabelAttr("position")
                            },
                          },
                          model: {
                            value: _vm.labelForm.position,
                            callback: function ($$v) {
                              _vm.$set(_vm.labelForm, "position", $$v)
                            },
                            expression: "labelForm.position",
                          },
                        },
                        _vm._l(_vm.labelPositionH, function (option) {
                          return _c("el-option", {
                            key: option.value,
                            attrs: { label: option.name, value: option.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("position-v"),
                          expression: "showProperty('position-v') ",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.label_position") },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: _vm.$t("chart.label_position"),
                          },
                          on: {
                            change: function ($event) {
                              return _vm.changeLabelAttr("position")
                            },
                          },
                          model: {
                            value: _vm.labelForm.position,
                            callback: function ($$v) {
                              _vm.$set(_vm.labelForm, "position", $$v)
                            },
                            expression: "labelForm.position",
                          },
                        },
                        _vm._l(_vm.labelPositionV, function (option) {
                          return _c("el-option", {
                            key: option.value,
                            attrs: { label: option.name, value: option.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("label-bg"),
                          expression: "showProperty('label-bg') ",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.label_bg") },
                    },
                    [
                      _c("el-color-picker", {
                        staticClass: "color-picker-style",
                        attrs: { predefine: _vm.predefineColors },
                        on: {
                          change: function ($event) {
                            return _vm.changeLabelAttr("bgColor")
                          },
                        },
                        model: {
                          value: _vm.labelForm.bgColor,
                          callback: function ($$v) {
                            _vm.$set(_vm.labelForm, "bgColor", $$v)
                          },
                          expression: "labelForm.bgColor",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("label-show-shadow"),
                          expression: "showProperty('label-show-shadow')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.label_shadow") },
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          on: {
                            change: function ($event) {
                              return _vm.changeLabelAttr("showShadow")
                            },
                          },
                          model: {
                            value: _vm.labelForm.showShadow,
                            callback: function ($$v) {
                              _vm.$set(_vm.labelForm, "showShadow", $$v)
                            },
                            expression: "labelForm.showShadow",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("chart.show")))]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.showProperty("label-shadow-color") &&
                            _vm.labelForm.showShadow,
                          expression:
                            "showProperty('label-shadow-color') && labelForm.showShadow",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.label_shadow_color") },
                    },
                    [
                      _c("el-color-picker", {
                        staticClass: "color-picker-style",
                        attrs: { predefine: _vm.predefineColors },
                        on: {
                          change: function ($event) {
                            return _vm.changeLabelAttr("shadowColor")
                          },
                        },
                        model: {
                          value: _vm.labelForm.shadowColor,
                          callback: function ($$v) {
                            _vm.$set(_vm.labelForm, "shadowColor", $$v)
                          },
                          expression: "labelForm.shadowColor",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("formatter"),
                          expression: "showProperty('formatter')",
                        },
                      ],
                      staticClass: "form-item",
                    },
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _c(
                          "span",
                          { staticClass: "span-box" },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("chart.content_formatter"))),
                            ]),
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: { effect: "dark", placement: "bottom" },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    attrs: { slot: "content" },
                                    slot: "content",
                                  },
                                  [
                                    _vm._v(
                                      "\n                  字符串模板 模板变量有："
                                    ),
                                    _c("br"),
                                    _vm._v("{a}：系列名。"),
                                    _c("br"),
                                    _vm._v("{b}：数据名。"),
                                    _c("br"),
                                    _vm._v("{c}：数据值。"),
                                    _c("br"),
                                    _vm._v(
                                      "{d}：百分比（用于饼图等）。\n                "
                                    ),
                                  ]
                                ),
                                _c("i", {
                                  staticClass: "el-icon-info",
                                  staticStyle: { cursor: "pointer" },
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          autosize: { minRows: 4, maxRows: 4 },
                        },
                        on: {
                          blur: function ($event) {
                            return _vm.changeLabelAttr("formatter")
                          },
                        },
                        model: {
                          value: _vm.labelForm.formatter,
                          callback: function ($$v) {
                            _vm.$set(_vm.labelForm, "formatter", $$v)
                          },
                          expression: "labelForm.formatter",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("gaugeFormatter"),
                      expression: "showProperty('gaugeFormatter')",
                    },
                  ],
                  staticClass: "form-item",
                },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _c("span", { staticClass: "span-box" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("chart.content_formatter"))),
                      ]),
                    ]),
                  ]),
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      autosize: { minRows: 4, maxRows: 4 },
                    },
                    on: {
                      blur: function ($event) {
                        return _vm.changeLabelAttr("gaugeFormatter")
                      },
                    },
                    model: {
                      value: _vm.labelForm.gaugeFormatter,
                      callback: function ($$v) {
                        _vm.$set(_vm.labelForm, "gaugeFormatter", $$v)
                      },
                      expression: "labelForm.gaugeFormatter",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }